import { Construtor } from './construtor';

export class Dashboard implements Construtor<Dashboard> {

    public idDashboard: number;
    public idCliente: number;
    public nomeDashboard: string;

    constructor(object?: any) {
        if (object !== undefined) {
            if (object instanceof (Dashboard)) {
                this.copyObject(object);
            } else {
                this.parseFromJson(object);
            }
            if (!this.modeloCompleto()) {
                return null;
            }
        }
    }

    parseFromJson(object: any): void {
        this.idDashboard = object.idDashboard;
        this.idCliente = object.idCliente;
        this.nomeDashboard = object.nomeDashboard;
    }

    copyObject(dashboard: Dashboard): void {
        this.idDashboard = dashboard.idDashboard;
        this.idCliente = dashboard.idCliente;
        this.nomeDashboard = dashboard.nomeDashboard;
    }

    modeloCompleto(): boolean {
        return this.nomeDashboard !== undefined;
    }

    getNewInstance(object?: any): Dashboard {
        return new Dashboard(object);
    }

}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/modelos/dashboard.ts